import { FunctionalComponent, h } from 'preact';

import { i18nTranslate } from 'common/helper/i18n/translate';
import { DropdownComponent } from 'common/module/dropdown/component';
import { BrokerCardTemplate } from 'desktop/module/broker/card/template';

import { BrokerListTemplatePropsInterface } from './template-props.interface';

/**
 * TODO-FE[WEB-1602]: Refactor this to work with common BrokerListTemplatePropsInterface
 */
export const BrokerListTemplate: FunctionalComponent<BrokerListTemplatePropsInterface> = (props) => (
  <div
    className={`
  container container--full-width
  ${props.disabled ? 'container--disabled' : ''}
`}
  >
    {!props.brokers.length ? (
      <div className='no-result-found no-result-found--style1'>
        <div className='no-result-found__content'>
          <h2 className='no-result-found__title'>
            {i18nTranslate('There are no companies matching your search requirements')}
          </h2>
          <div className='no-result-found__sub-heading'>{i18nTranslate('You could try the following')}:</div>
          <ul className='no-result-found__list'>
            <li className='no-result-found__list-item'>{i18nTranslate('Adjust the filters in your search')}</li>
          </ul>
        </div>
        <div className='no-result-found__img'>
          <img src={__('assets/desktop/notfound.png')} alt={i18nTranslate('Not found')} />
        </div>
      </div>
    ) : (
      [
        <div className='heading'>
          <h1 className='title'>{props.title}</h1>
          {!!props.orderBy && (
            <div className='heading__filters'>
              <div className='heading__filter-label'>{i18nTranslate('Sort by')}</div>
              <DropdownComponent {...props.orderBy} />
            </div>
          )}
        </div>,
        <div className='tiles'>
          {props.brokers.map((broker, index) => (
            <a className='tiles__tile' href={broker.broker.links.profile} title={broker.broker.name}>
              <BrokerCardTemplate
                {...broker}
                onComponentDidMount={(element: HTMLElement) => broker.onCreateTemplate(element, index)}
              />
            </a>
          ))}
        </div>,
      ]
    )}
  </div>
);
